/* eslint-disable react-hooks/exhaustive-deps */
import { useAppSelector } from 'app/hooks';
import {
  optionStringValues,
  setArrayLength,
} from 'components/helper/helper';
import CheckboxInput from 'components/input/CheckboxInput';
import GroupRadioButton from 'components/input/GroupRadioButton';
import SelectInput from 'components/input/SelectInput';
import TextInput from 'components/input/textInput';
import React, { useEffect, useMemo, useState } from 'react';
import { Row } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import {
  AToFGrade,
  getSubjectsByType,
  gradingOptionKeys,
  subjectAreaOptions,
  to100Grade,
  to4Grade,
} from 'screen/course/courseConstant';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid from '@mui/joy/Grid';
export const gardingScaleOptions = ['A-F', '0-100', '0-105', '0-110', '0.0-4.0', '0.0-5.0', '1-7 (IB)', '1-10', '1-11', '1-20', 'Other'];
export type TMiddleCourseWork = {
  school: string;
  grade_level: string;
  school_year: string;
  grade_scale: string;
  term_period: string; // period,
  schedule: string;
  describe_other_schedule: string;
  course_name: string;
  course_name_for_UC: string;
  subject_discipline: string;
  language_name_for_UC: string;
  course_category: string;
  ag_subject_requirement: string;
  type_of_class: string;
  is_weighted_course: string;
  is_take_class_at_college: boolean;
  college: string;
  grades: string[];
  credits: string[];

  final_grade: string | number;
  final_credit: string | number;
  not_information: string[];
  isFirstSemester: boolean;
  isSecondSemester: boolean;
  isThirdSemester: boolean;
  isFourthSemester: boolean;
};
export type TAdditionalInfoCourse = {
  high_school_academic_performance: string;
  degree_or_diploma_name: string;
  completed_high_school_outside_US: 'true' | 'false' | '';
  is_take_course_in_middle_school: 'true' | 'false' | '';
  is_have_course_issued_official_transcript_grades: 'true' | 'false' | '';
  course_work: TMiddleCourseWork[];
};

export const initialValuesMiddleCourseWork: TMiddleCourseWork = {
  school: '',
  grade_level: '',
  school_year: '',
  grade_scale: '',
  term_period: '',
  schedule: '',
  describe_other_schedule: '',
  course_name: '',
  course_name_for_UC: '',
  subject_discipline: '',
  language_name_for_UC: '',
  course_category: '',
  ag_subject_requirement: '',
  type_of_class: '',
  is_weighted_course: '',
  is_take_class_at_college: false,
  college: '',
  grades: ['', '', '', ''],
  credits: ['', '', '', ''],
  final_grade: '',
  final_credit: '',
  not_information: [],
  isFirstSemester: false,
  isSecondSemester: false,
  isThirdSemester: false,
  isFourthSemester: false,
};

interface Props {
  index: number; // start 0
  formik: any;
  expandAll?: boolean;
  handleExpandActive: (value: any) => void;
  isMobile?: boolean;
  disabled?: boolean;
}

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

const MiddleCourseWork = ({ formik, index, expandAll, handleExpandActive, isMobile = false, disabled = false }: Props) => {
  const [countGrades, setCountGrades] = React.useState(4);
  const [expanded, setExpanded] = React.useState(expandAll || false);
  const highSchoolData = useAppSelector((store) => store.highSchool.highSchoolData);
  const collegeData = useAppSelector((store) => store.highSchool.collegeData);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const check = query.get('check');

  const buildName = (name: string) => {
    return `additional_info.course_work[${index}].${name}`;
  };
  const buildLabelName = (name: string) => {
    return `additional_info.course_work_${index}_${name}`;
  };
  const formItemValues = formik.values.additional_info?.course_work?.[index];

  const buildGradingOptions = (scale?: string) => {
    let result: any[] = [];
    switch (scale) {
      case 'A-F':
        result = AToFGrade;
        break;
      case '0-100':
      case '0-105':
        result = [
          ...optionStringValues(Array.from({ length: 106 }, (_, i) => i).reverse()),
          ...to100Grade,
        ];
        break;
      case '0-110':
        result = [
          ...optionStringValues(Array.from({ length: 111 }, (_, i) => i).reverse()),
          ...to100Grade,
        ];
        break;
      case '0.0-4.0':
        result = [
          ...optionStringValues(Array.from({ length: 41 }, (_, i) => i / 10).reverse()),
          ...to4Grade,
        ];
        break;
      case '0.0-5.0':
        result = [
          ...optionStringValues(Array.from({ length: 51 }, (_, i) => i / 10).reverse()),
          ...to4Grade,
        ];
        break;
      case '1-7 (IB)':
        result = [
          ...optionStringValues(Array.from({ length: 7 }, (_, i) => i + 1).reverse()),
          ...to4Grade,
        ];
        break;
      case '1-10':
        result = [
          ...optionStringValues(Array.from({ length: 10 }, (_, i) => i + 1).reverse()),
          ...to4Grade,
        ];
        break;
      case '1-11':
        result = [
          ...optionStringValues(Array.from({ length: 11 }, (_, i) => i + 1).reverse()),
          ...to4Grade,
        ];
        break;
      case '1-20':
        result = [
          ...optionStringValues(Array.from({ length: 20 }, (_, i) => i + 1).reverse()),
          ...to4Grade,
        ];
        break;
      default:
        result = [];
    }

    return [null, ...result];
  };

  const initGradingOptions = () => {
    return buildGradingOptions(formItemValues?.grade_scale);
  };

  const initSchedule = () => {
    switch (formItemValues?.schedule) {
      case 'Semester':
        setCountGrades(2);
        formik.setFieldValue(buildName('credits'), setArrayLength(formItemValues?.credits, 2, ''));
        formik.setFieldValue(buildName('grades'), setArrayLength(formItemValues?.grades, 2, ''));
        break;
      case 'Trimester':
        setCountGrades(3);
        formik.setFieldValue(buildName('credits'), setArrayLength(formItemValues?.credits, 3, ''));
        formik.setFieldValue(buildName('grades'), setArrayLength(formItemValues?.grades, 3, ''));
        break;
      case 'Quarters':
        setCountGrades(4);
        formik.setFieldValue(buildName('credits'), setArrayLength(formItemValues?.credits, 4, ''));
        formik.setFieldValue(buildName('grades'), setArrayLength(formItemValues?.grades, 4, ''));
        break;
      default:
        setCountGrades(0);
        formik.setFieldValue(buildName('credits'), []);
        formik.setFieldValue(buildName('grades'), []);
    }
  };

  React.useEffect(() => {
    initSchedule();
  }, [formItemValues?.schedule]);

  const [gradingOptions, setGradingOptions] = useState<any[]>([]);

  useEffect(() => {
    setGradingOptions(initGradingOptions());
  }, [formItemValues?.grade_scale]);


  const SemesterOption = () => {
    let options: any = [];
    switch (formItemValues.schedule) {
      case 'Quarters':
        options = [
          { value: 'isFirstSemester', label: 'First Quarter', fieldIndex: 0 },
          { value: 'isSecondSemester', label: 'Second Quarter', fieldIndex: 1 },
          { value: 'isThirdSemester', label: 'Third Quarter', fieldIndex: 2 },
          { value: 'isFourthSemester', label: 'Fourth Quarter', fieldIndex: 3 },
        ];
        break;
      case 'Trimester':
        options = [
          { value: 'isFirstSemester', label: 'First Trimester', fieldIndex: 0 },
          { value: 'isSecondSemester', label: 'Second Trimester', fieldIndex: 1 },
          { value: 'isThirdSemester', label: 'Third Trimester', fieldIndex: 2 },
        ];
        break;
      case 'Semester':
        options = [
          { value: 'isFirstSemester', label: 'First Semester', fieldIndex: 0 },
          { value: 'isSecondSemester', label: 'Second Semester', fieldIndex: 1 },
        ];
        break;
      default:
        break;
    }

    return (
      <>
        <div
          id={`takeSemester_${index + 1}`}
          className="mb-3 label-14px text-bold"
          style={{
            backgroundColor:
              !(
                formItemValues?.isFirstSemester ||
                formItemValues?.isSecondSemester ||
                formItemValues?.isThirdSemester ||
                formItemValues?.isFourthSemester
              ) && check
                ? '#FFEBEB'
                : '',
            display: 'inline-block',
          }}
        >
          During which {formItemValues.schedule?.toLowerCase() ?? 'term'}(s) did you take this
          class? *
        </div>
        {options.map((opt: any, index: number) => {
          let key = opt.value as any;
          return (
            <CheckboxInput
              className='mb-3'
              key={index}
              name={buildName(key)}
              label={opt.label}
              onChange={formik.handleChange}
              values={formItemValues?.[key]}
            />
          );
        })}
      </>
    );
  };

  const buildCardTitle = (name: string[]) => {
    return name
      .filter((item) => item !== '')
      .map((item) => {
        let value = formItemValues?.[item];

        // Handle case where value is an array
        if (Array.isArray(value)) {
          value = value.filter((v) => v !== '').join(', '); // Filter out empty strings and join the non-empty values
        }

        // Skip if the value is empty after filtering
        if (!value) {
          return '';
        }

        // Format the item with an uppercase prefix if it's one of the specified items
        if (['credits', 'grades', 'final_grade', 'final_credit'].includes(item)) {
          const formattedItem = item
            .split('_')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
          return `${formattedItem}: ${value}`;
        }

        return `${value}`;
      })
      .filter(Boolean) // Remove empty strings
      .join(' - ');
  };

  const handleExpandClick = () => {
    setExpanded(!expanded);
    handleExpandActive(expanded);
  };

  React.useEffect(() => {
    setExpanded(expandAll || false);
  }, [expandAll]);

  return formItemValues ? (
    <Card className="w-100 mb-2 px-0" key={`middle-course-${index}`}>
      <CardActions
        id={`midCoureItem${index + 1}`}
        disableSpacing
        onClick={handleExpandClick}
        sx={{
          backgroundColor: expanded ? '#AAEBF7' : 'none',
          borderBottom: expanded ? '2px solid #4D88F0' : 'none',
          marginLeft: '-8px',
        }}
        style={{ cursor: 'pointer' }}
      >
        <div className="w-100 d-flex justify-content-between ps-3">
          <span className="p-1">
            {buildCardTitle([
              'school',
              'schedule',
              'course_name',
              'grades',
              'credits',
              'final_grade',
              'final_credit',
            ])}
          </span>
          <strong className="text-field-light">{`${index + 1}/${formik.values.additional_info?.course_work?.length || 1}`}</strong>
        </div>
        <ExpandMore
          expand={expanded}
          onClick={(e) => {
            e.stopPropagation();
            handleExpandClick();
          }}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </ExpandMore>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent className="gm-card-content">
          <Grid container spacing={2} className="px-3 gm-form-fields">
            <Grid xs={12}>
              <SelectInput
                id={`school_${index + 1}`}
                label="Select the school for this coursework*"
                option={highSchoolData.map((i) => i.id)}
                placeholder="Search your school"
                name={buildName('school')}
                values={formItemValues?.school}
                onChange={formik.handleChange}
                isMissing={!formItemValues?.school && check ? true : false}
                disabled={disabled}
              />
            </Grid>
            <Grid xs={12} md={6}>
              <SelectInput
                id={`gradeLevel_${index + 1}`}
                label="Grade Level*"
                option={['8th Grade', '7th Grade']}
                name={buildName('grade_level')}
                values={formItemValues?.grade_level}
                onChange={formik.handleChange}
                isMissing={!formItemValues?.grade_level && check ? true : false}
                disabled={disabled}
              />
            </Grid>
            <Grid xs={12} md={6}>
              <SelectInput
                id={`schoolYear_${index + 1}`}
                label="School Year*"
                option={[
                  '2028-29',
                  '2027-28',
                  '2026-27',
                  '2025-26',
                  '2024-25',
                  '2023-24',
                  '2022-23',
                  '2021-22',
                  '2020-21',
                  '2019-20',
                  '2018-19',
                  '2017-18',
                  '2016-17',
                ]}
                name={buildName('school_year')}
                values={formItemValues?.school_year}
                onChange={formik.handleChange}
                isMissing={!formItemValues?.school_year && check ? true : false}
                disabled={disabled}
              />
            </Grid>
            <Grid xs={12} md={6}>
              <SelectInput
                id={`gradeScale_${index + 1}`}
                label="Grading Scale*"
                option={gardingScaleOptions}
                name={buildName('grade_scale')}
                values={formItemValues?.grade_scale}
                onChange={(e: any) => {
                  try {
                    const newScale = e.target.value;
                    formik.setFieldValue(buildName('grade_scale'), newScale);
                    const nextOptions = buildGradingOptions(newScale);
                    setGradingOptions(nextOptions);
                    const allowed = gradingOptionKeys(nextOptions);

                    // Only clear grades invalid under the new scale
                    if (formItemValues?.grades && formItemValues?.grades.length > 0) {
                      for (var k = 0; k < formItemValues.grades.length; k++) {
                        const g = formItemValues.grades[k];
                        if (g === '' || g === undefined) continue;
                        const key = g === null ? null : String(g);
                        if (!allowed.has(key)) {
                          formik.setFieldValue(buildName(`grades[${k}]`), '');
                        }
                      }
                    }

                    if (formItemValues?.schedule_transcript !== 'One grade per term') {
                      const finalGrade = formItemValues?.final_grade;
                      if (finalGrade !== '' && finalGrade !== undefined) {
                        const finalKey = finalGrade === null ? null : String(finalGrade);
                        if (!allowed.has(finalKey)) {
                          formik.setFieldValue(buildName(`final_grade`), '');
                        }
                      }
                    }
                  } catch (ex) {
                    console.log('Error: ', ex);
                  }
                }}
                isMissing={!formItemValues?.grade_scale && check ? true : false}
                disabled={disabled}
              />
            </Grid>
            <Grid xs={12} md={6}>
              <SelectInput
                id={`termPeriod_${index + 1}`}
                label="Term period*"
                option={['--select--', 'Full year', 'Less than full year']}
                name={buildName('term_period')}
                values={formItemValues?.term_period}
                onChange={formik.handleChange}
                isMissing={!formItemValues?.term_period && check ? true : false}
                disabled={disabled}
              />
            </Grid>
            <Grid xs={12} md={6}>
              <SelectInput
                id={`schedule_${index + 1}`}
                label="Schedule*"
                option={['Semester', 'Trimester', 'Quarters', 'Yearly', 'Other']}
                name={buildName('schedule')}
                values={formItemValues?.schedule}
                onChange={(e) => {
                  formik.handleChange(e);
                  formik.setFieldValue(buildName(`schedule_transcript`), '');
                }}
                isMissing={!formItemValues?.schedule && check ? true : false}
                disabled={disabled}
              />
            </Grid>
            {formItemValues?.schedule === 'Other' && (
              <Grid xs={12} md={6}>
                <TextInput
                  id={`describeOtherSchedule_${index + 1}`}
                  label="Please describe schedule*"
                  name={buildName('describe_other_schedule')}
                  values={formItemValues?.describe_other_schedule}
                  countText={20}
                  onChange={formik.handleChange}
                  isMissing={!formItemValues?.describe_other_schedule && check ? true : false}
                  disabled={disabled}
                />
              </Grid>
            )}
            <Grid xs={12} md={6}>
              <SelectInput
                id={`AGsubjectRequirement_${index + 1}`}
                option={subjectAreaOptions}
                logo="span-uc-csu-logo"
                label="A-G Subject Requirement"
                isUcCsuLogo={true}
                values={formItemValues?.ag_subject_requirement}
                name={buildName('ag_subject_requirement')}
                onChange={formik.handleChange}
                feedback={'If Science, please select D1 - Biological Science or D2 - Physical Science.'}
                isMissing={!formItemValues?.ag_subject_requirement && check ? true : false}
                disabled={disabled}
              />
            </Grid>
            {formItemValues?.ag_subject_requirement === 'E Language Other than English' && (
              <>
                <Grid xs={12} md={6}>
                  <SelectInput
                    id={`languageNameforUC_${index + 1}`}
                    option={[
                      '--',
                      'American Sign Language',
                      'Arabic',
                      'Armenian',
                      'Chinese',
                      'Farsi',
                      'Filipino',
                      'French',
                      'German',
                      'Greek',
                      'Hebrew',
                      'Hindi',
                      'Hmong',
                      'Italian',
                      'Japanese',
                      'Khmer',
                      'Korean',
                      'Latin',
                      'Other Language',
                      'Portuguese',
                      'Punjabi',
                      'Russian',
                      'Spanish',
                      'Tamil',
                      'Turkish',
                      'Vietnamese',
                    ]}
                    label="Language Name"
                    values={formItemValues?.language_name_for_UC}
                    name={buildName('language_name_for_UC')}
                    onChange={formik.handleChange}
                    isMissing={!formItemValues?.language_name_for_UC && check ? true : false}
                    disabled={disabled}
                  />
                </Grid>
                <Grid xs={12} md={6}>
                  <SelectInput
                    id={`courseCategory_${index + 1}`}
                    option={[
                      'Yr 1 Lang Other than English',
                      'Yr 2 Lang Other than English',
                      'Yr 3 Lang Other than English',
                      'Yr 4+ Lang Other than English',
                    ]}
                    label="Course category *"
                    isSatTest={true}
                    values={formItemValues?.course_category}
                    name={buildName('course_category')}
                    onChange={formik.handleChange}
                    logo="span-uc-logo"
                    isMissing={!formItemValues?.course_category && check ? true : false}
                    disabled={disabled}
                  />
                </Grid>
              </>
            )}
            <Grid xs={12}>
              <SelectInput
                id={`subjectDiscipline_${index + 1}`}
                logo="span-cm-logo"
                option={getSubjectsByType(formItemValues?.ag_subject_requirement)}
                label="Subject/Discipline"
                isSatTest={true}
                values={formItemValues?.subject_discipline}
                name={buildName('subject_discipline')}
                onChange={formik.handleChange}
                isMissing={!formItemValues?.subject_discipline && check ? true : false}
                disabled={disabled}
              />
            </Grid>
            {formItemValues?.ag_subject_requirement === 'C Mathematics' && (
              <Grid xs={12} md={6}>
                <SelectInput
                  id={`courseNameforUC_${index + 1}`}
                  logo="span-uc-logo"
                  isCMLogo={true}
                  option={[
                    'Algebra I',
                    'Geometry',
                    'Algebra II',
                    'Algebra II/Trigonometry',
                    'Advanced Functions',
                    'Mathematics I',
                    'Mathematics II',
                    'Mathematics III',
                    'Trigonometry',
                    'Pre-Caculus',
                    'Statistics',
                    'Calculus',
                    'Discrete Math',
                    'Finite Math',
                    'Other Advanced Math',
                  ]}
                  label="Course name *"
                  values={formItemValues?.course_name_for_UC}
                  name={buildName('course_name_for_UC')}
                  onChange={formik.handleChange}
                  isMissing={!formItemValues?.course_name_for_UC && check ? true : false}
                  disabled={disabled}
                />
              </Grid>
            )}
            <Grid xs={12} md={formItemValues?.ag_subject_requirement === 'C Mathematics' ? 6 : 12}>
              <TextInput
                id={`courseName_${index + 1}`}
                logo="span-cm-logo"
                label="Course Name*"
                isTestCsuLogo={true}
                name={buildName('course_name')}
                values={formItemValues?.course_name}
                countText={20}
                onChange={formik.handleChange}
                isMissing={!formItemValues?.course_name && check ? true : false}
                disabled={disabled}
              />
            </Grid>
 
            <Grid xs={12} md={6}>
              <SelectInput
                id={`typeOfClass_${index + 1}`}
                option={[
                  'Regular',
                  'Accelerated',
                  'Advanced',
                  'Advanced Placement (AP)',
                  'AS/A-Level/International A-Level/Cambridge AICE',
                  'College Prep',
                  'Dual Enrollment',
                  'Enriched',
                  'GSCE/IGSCE',
                  'Gifted',
                  'High Honors',
                  'Honors',
                  'Intensive',
                  'International Baccalaureate (IB)',
                  'Pre-IB',
                  'Regents',
                  'Other ',
                ]}
                label="Type of Class *"
                values={formItemValues?.type_of_class}
                name={buildName('type_of_class')}
                onChange={formik.handleChange}
                isMissing={!formItemValues?.type_of_class && check ? true : false}
                disabled={disabled}
              />
            </Grid>
            <Grid xs={12} md={6}>
              <SelectInput
                option={['', 'Yes', 'No']}
                label="Is this a weighted course?"
                values={formItemValues?.is_weighted_course}
                name={buildName('is_weighted_course')}
                onChange={formik.handleChange}
                disabled={disabled}
              />
            </Grid>
            <Grid xs={12}>
              <CheckboxInput
                className="mb-3"
                label="I took this class at a college and/or I received college credit for this class."
                name={buildName('is_take_class_at_college')}
                values={formItemValues?.is_take_class_at_college}
                onChange={formik.handleChange}
                disabled={disabled}
              />
            </Grid>
            {formItemValues?.is_take_class_at_college && (
              <Grid xs={12}>
                <GroupRadioButton
                  id={`college_${index + 1}`}
                  label="Select College *"
                  options={collegeData}
                  mdCol={12}
                  name={buildName('college')}
                  values={formItemValues?.college}
                  onChange={formik.handleChange}
                  isMissing={
                    (!formItemValues?.college || !collegeData.includes(formItemValues?.college)) && check
                      ? true
                      : false
                  }
                  disabled={disabled}
                />
              </Grid>
            )}
            <Grid xs={12}>
              <SemesterOption />
            </Grid>
            {['Semester', 'Trimester', 'Quarters'].includes(formItemValues?.schedule) && (
              <Grid xs={12}>
                <GroupRadioButton
                  verticalLayout={true}
                  id={`scheduleTranscript_${index + 1}`}
                  className="py-3"
                  mdCol={12}
                  options={[
                    'One final Grade',
                    'One grade per term',
                    'One grade per term and one final grade',
                  ]}
                  label="How are the grades for this class reported on your transcript?"
                  values={formItemValues?.schedule_transcript}
                  name={buildName(`schedule_transcript`)}
                  onChange={(e: any) => {
                    formik.setFieldValue(buildName(`schedule_transcript`), e.target.value);
                    initSchedule();
                  }}
                  isMissing={!formItemValues?.schedule_transcript && check ? true : false}
                  disabled={disabled}
                />
              </Grid>
            )}
            {(formItemValues?.grades ?? []).map((item: string, i: number) => {
              if (formItemValues?.schedule_transcript === 'One final Grade') return null;
              if (i === 0 && !formItemValues?.isFirstSemester) return null;
              if (i === 1 && !formItemValues?.isSecondSemester) return null;
              if (i === 2 && !formItemValues?.isThirdSemester) return null;
              if (i === 3 && !formItemValues?.isFourthSemester) return null;
              if (i < countGrades) {
                return (
                  <Grid container  xs={12} spacing={2} key={i}>
                    <Grid  xs={12} md={6}>
                      {formItemValues?.grade_scale === 'Other' ? (
                        <TextInput
                          id={`grade_${index + 1}_${i}`}
                          label="Grade*"
                          countText={5}
                          name={buildLabelName(`grades[${i}]`)}
                          values={formItemValues?.grades[i]}
                          onChange={(e: any) => {
                            formik.setFieldValue(buildName(`grades[${i}]`), e.target.value);
                            formik.handleChange(e);
                          }}
                          isMissing={!formItemValues?.grades[i] && check ? true : false}
                          disabled={disabled}
                        />
                      ) : (
                        <SelectInput
                          id={`grade_${index + 1}_${i}`}
                          option={gradingOptions}
                          label="Grade*"
                          values={formItemValues?.grades[i]}
                          name={buildLabelName(`grades[${i}]`)}
                          onChange={(e) => {
                            formik.setFieldValue(buildName(`grades[${i}]`), e.target.value);
                            formik.handleChange(e);
                          }}
                          isMissing={!formItemValues?.grades[i] && check ? true : false}
                          disabled={disabled}
                        />
                      )}
                    </Grid>
                    <Grid xs={12} md={6}>
                      <TextInput
                        id={`credits_${index + 1}_${i}`}
                        label="Credits*"
                        decimalStep={0.001}
                        type="number"
                        name={buildLabelName(`credits[${i}]`)}
                        values={formItemValues?.credits[i]}
                        onChange={(e) => {
                          formik.setFieldValue(
                            buildName(`credits[${i}]`),
                            Math.round(e.target.value * 1000) / 1000
                          );
                        }}
                        isMissing={!formItemValues?.credits[i] && check ? true : false}
                        disabled={disabled}
                      />
                    </Grid>
                  </Grid>
                );
              } else {
                return null;
              }
            })}
            {formItemValues?.schedule_transcript !== 'One grade per term' && (
              <Grid xs={12} md={6}>
                {formItemValues?.grade_scale === 'Other' ? (
                  <TextInput
                    id={`finalGrade_${index + 1}`}
                    label="Final Grade*"
                    countText={5}
                    name={buildName('final_grade')}
                    values={formItemValues?.final_grade}
                    onChange={formik.handleChange}
                    isMissing={!formItemValues?.final_grade && check ? true : false}
                    disabled={disabled}
                  />
                ) : (
                  <SelectInput
                    id={`finalGrade_${index + 1}`}
                    option={gradingOptions}
                    label="Final Grade*"
                    values={formItemValues?.final_grade}
                    name={buildName('final_grade')}
                    onChange={formik.handleChange}
                    isMissing={!formItemValues?.final_grade && check ? true : false}
                    disabled={disabled}
                  />
                )}
              </Grid>
            )}
            {formItemValues?.schedule_transcript !== 'One grade per term' && (
              <Grid xs={12} md={6}>
                <TextInput
                  id={`finalCredits_${index + 1}`}
                  label="Final Credits*"
                  decimalStep={0.001}
                  type="number"
                  name={buildName('final_credit')}
                  values={formItemValues?.final_credit}
                  onChange={(e) => {
                    formik.setFieldValue(buildName('final_credit'), Math.round(e.target.value * 1000) / 1000);
                  }}
                  isMissing={!formItemValues?.final_credit && check ? true : false}
                  disabled={disabled}
                />
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Collapse>
    </Card>
  ) : null;
};

export default MiddleCourseWork;
